import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { take, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Cash4Bike } from '../models/Cash4Bike';
import { DataService } from './data.service';
import { ToastComponent } from '../shared/toast/toast.component';
@Injectable({
  providedIn: 'root'
})
export class Cash4BikeService {
  cash4BikeDoc: AngularFirestoreDocument<Cash4Bike>;
  constructor(private firestore: AngularFirestore, public dataService: DataService,public toastComponent: ToastComponent) {this.toastComponent = toastComponent }
  //standard values when creating a new business
  cash4Bike: Cash4Bike = {
    tekstJaarlijkseLeaseKost: "Maandelijkse leaseprijs * 12",
    tekstBrutoPerJaar: "in te leveren bruto per maand * 13,92 ",
    tekstDetailsPatronaleRSZ: "in te leveren bruto per maand * 13,92 * %",
    infoPatronaleRSZ: "Patronale RSZ bedienden 25 % / arbeiders 30.57 %",

    tekstWaarschuwing: "Deze simulatie is niet van toepassing op arbeiders, enkel voor bedienden en enkel van toepassing indien er een betaling is over 13,92 maanden.",
   }
   
  getCash4Bike(id:string): Observable<Cash4Bike>
  {
    return this.firestore.collection("Cash4Bike").doc<Cash4Bike>(id).get().pipe(take(1),
    map(queryResult => {

      if(queryResult.exists ){

        const data =  queryResult.data() as Cash4Bike;
        const id = queryResult.id;
        this.dataService.cash4Bike = data;
        return {id, ...data};
        }
        else{
          return null;
        }
      }));
  }
  async addCash4Bike()
  {
    let cash4BikeId = '';
    await this.firestore.collection("Cash4Bike").add(this.cash4Bike).then(function(docRef){
      cash4BikeId = docRef.id
    })
    return cash4BikeId;
  }
  //Deze methode wordt alleen gebruikt wanneer de priveAdmin een nieuwe onderneming aanmaakt.
  updateNaToevoegen(id: string, ondernemingId:string,ondernemingNaam:string)
  {
  this.cash4Bike.ondernemingId = ondernemingId;
  this.cash4Bike.ondernemingNaam = ondernemingNaam;
    this.cash4Bike.id = id;
    this.updateCash4Bike(this.cash4Bike);
  }
  async updateCash4Bike(cash4Bike: Cash4Bike) {
    try {
      this.cash4BikeDoc = this.firestore.doc(`Cash4Bike/${cash4Bike.id}`);
      await this.cash4BikeDoc.update(cash4Bike);
      this.dataService.cash4Bike = cash4Bike;
      this.toastComponent.showSuccess();
    } catch (err) {
      console.log(err);
    }
  }
  deleteCash4Bike(id: string){
    this.cash4BikeDoc = this.firestore.doc(`Cash4Bike/${id}`);
    this.cash4BikeDoc.delete();
  }

}
